import { MemberFiltersSchema } from "@domains/reviews/shared/reviewee-filters/memberFilters.ts";
import { ReviewThemesWithCountsSchema } from "@domains/reviews/shared/reviewThemeCounts.ts";
import { oc } from "@orpc/contract";
import { z } from "zod";
import { PeriodSelectionSchema } from "#shared/periodSelection.ts";

export { ThemeSentimentClassSchema, type ReviewThemesWithCounts, type ReviewThemeWithCounts } from "@domains/reviews/shared/reviewThemeCounts.ts";
export { ReviewThemeSchema } from "@domains/reviews/shared/reviewThemes.ts";

export const ReviewThemesSelectionSchema = z.object({
    ...PeriodSelectionSchema.shape,
    ...MemberFiltersSchema.shape
});
export type ReviewThemesSelection = z.infer<typeof ReviewThemesSelectionSchema>;

export const REVIEW_THEMES_EXPORT_PATH = "/api/analytics/review-themes/export";

export const reviewThemesContract = {
    getCrossCycleReviewThemes: oc
        .route({ method: "GET", path: "/get-cross-cycle-review-themes" })
        .errors({
            UPSTREAM_FAILURE: {},
            FORBIDDEN: {}
        })
        .input(ReviewThemesSelectionSchema)
        .output(ReviewThemesWithCountsSchema)
};
